export const BASE_API_URL = process.env.BASE_API_URL || 'http://localhost:4000'